import { render, staticRenderFns } from "./InventoryPage.vue?vue&type=template&id=67053d3b&scoped=true&"
import script from "./InventoryPage.vue?vue&type=script&lang=js&"
export * from "./InventoryPage.vue?vue&type=script&lang=js&"
import style0 from "./InventoryPage.vue?vue&type=style&index=0&id=67053d3b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67053d3b",
  null
  
)

export default component.exports